import { DataActiveStatusEnum } from "../../Category/types";
import { CategoryRetailerState,  IData } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  sortOrder: 0,
  status: DataActiveStatusEnum.ACTIVE,
};

export const initialState: CategoryRetailerState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
};
